import React from "react";
import Reseller from "../../Models/Reseller";
import { Button, DialogContent, GridLegacy, Paper, Switch, Typography } from "@mui/material";
import { useDialog } from "../../utils/DialogProvider";
import GridRowDescriptionWithTextField from "../components/EditFields/GridRowDescriptionWithTextField";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper";
// @ts-ignore
import AsynchronousAutocomplete from "../../../components/Autocomplete/AsynchronousAutocomplete";

type EditResellerProps = {
  reseller: Reseller;
  onSave: (reseller: Reseller) => Promise<any>;
};

function EditReseller(props: EditResellerProps) {
  const [reseller, setReseller] = React.useState<Reseller>(props.reseller);

  const [, closeDialog] = useDialog();
  return (
    <DialogContent>
      <Paper>
        <Typography variant={"h6"}>Reseller</Typography>

        <GridLegacy container spacing={1} style={{ maxWidth: 480 }}>
          <GridLegacy container item xs={12}>
            <GridRowDescriptionWithTextField
              description={"Name"}
              onChange={(e) => {
                reseller.description = e.target.value;
                setReseller(Object.assign(Object.create(reseller), reseller));
              }}
              value={reseller.description}
            />
          </GridLegacy>

          <GridLegacy container item xs={12}>
            <GridLegacy item xs={6}>
              <TranslationWrapper tDefault={"transactionKickback"} tKey={"transactionKickback"} />
            </GridLegacy>
            <GridLegacy item xs={6}>
              <Switch
                checked={reseller.transactionKickback}
                onChange={(e) => {
                  reseller.transactionKickback = e.target.checked;
                  setReseller(Object.assign(Object.create(reseller), reseller));
                }}
              />
            </GridLegacy>
          </GridLegacy>

          <GridLegacy container item xs={12}>
            <GridLegacy item xs={6}>
              <TranslationWrapper tKey={"Debtor"} />
            </GridLegacy>
            <GridLegacy item xs={6}>
              <AsynchronousAutocomplete
                async={{
                  url: "core/subsDebtor/search?fields=id as value, company_name as label&per_page=30",
                  searchField: "company_name",
                }}
                disableClearable={true}
                onChange={(e: any, option: any) => {
                  reseller.subs_debtor_id = option.value;
                  setReseller(Object.assign(Object.create(reseller), reseller));
                }}
              />
            </GridLegacy>
          </GridLegacy>

          {props.onSave ? (
            <GridLegacy container item justify={"center"} xs={12}>
              <Button
                color={"primary"}
                onClick={() => {
                  if (props.onSave) {
                    props.onSave(reseller).then(() => {
                      closeDialog();
                    });
                  }
                }}
                variant={"contained"}
              >
                Save
              </Button>
            </GridLegacy>
          ) : null}
        </GridLegacy>
      </Paper>
    </DialogContent>
  );
}

export default EditReseller;
